<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div style="padding: 1rem;">
      <div class="main-box bc-body">
        <!-- <div class="label">{{ $t("setting.fill_bank_tip") }}</div> -->
        <van-cell-group>
          <van-field
            v-model="bank"
            :label="$t('setting.band_name')"
            :placeholder="$t('setting.band_name_tip')"
          />
          <van-field
            v-model="username"
            :label="$t('setting.username')"
            :placeholder="$t('setting.username_place')"
          />
          <van-field
            v-model="branch_name"
            :label="$t('setting.branch_name')"
            :placeholder="$t('setting.branch_name_tip')"
          />
          <van-field
            v-model="bank_code"
            :label="$t('setting.bank_code')"
            :placeholder="$t('setting.bank_code_tip')"
          />
          <van-field
            v-model="bankid"
            :label="$t('setting.band_account')"
            type="text"
            :placeholder="$t('setting.band_account_tip')"
          />
          <van-field
            v-model="opw"
            type="password"
            :label="$t('setting.money_place')"
            :placeholder="$t('setting.money_place2')"
          />
          <!-- <van-field
            v-model="tpw"
            type="password"
            :label="$t('setting.money_again_place')"
            :placeholder="$t('setting.money_again_place')"
          /> -->
          <!-- <van-field
            v-model="mobile"
            :label="$t('setting.mobile')"
            type="digit"
            :placeholder="$t('setting.mobile_place')"
          /> -->
        </van-cell-group>
      </div>
    </div>
    <p class="bank-warning">{{ $t("setting.bank_warn") }}</p>
    <van-button class="bindCard" type="default" @click="bindCard()">{{
      $t("setting.bank_ok")
    }}</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      bankid: "",
      username: "",
      mobile: "123456",
      bank: "",
      branch_name: "",
      bank_code: "",
      opw: "",
      tpw: "",
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    bindCard() {
      if (this.userInfo.bankid) {
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }
      if (!this.bank) {
        this.$toast.fail(this.$t("setting.band_name_tip"));
        return false;
      }

      if (!this.username) {
        this.$toast(this.$t("setting.username_place"));
        return false;
      }
      if (!this.branch_name) {
        this.$toast(this.$t("setting.branch_name_tip"));
        return false;
      }
      if (!this.bank_code) {
        this.$toast(this.$t("setting.bank_code_tip"));
        return false;
      }
      if (!this.bankid) {
        this.$toast(this.$t("setting.band_account_tip"));
        return false;
      }
      if (!this.opw) {
        this.$toast(this.$t("setting.money_place2"));
        return false;
      }

      this.$http({
        method: "post",
        data: {
          bankid: this.bankid,
          bank: this.bank,
          branch_name: this.branch_name,
          bank_code: this.bank_code,
          username: this.username,
          mobile: this.mobile,
          opw: this.opw,
          tpw: this.opw,
        },
        url: "user_set_bank",
      }).then((res) => {
        if (res.code === 200) {
          this.$router.push({ path: "/Mine" });
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getBankList() {
      this.$http({
        method: "get",
        url: "sys_get_banks",
      }).then((res) => {
        if (res.code === 200) {
          this.banks = res.data;
          console.log("获取到的银行:", res.data);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";
::v-deep .van-field__control{
  font-size: 0.9rem;
  width: 55vw;
}
::v-deep .van-cell-group {
  background: none;
}
::v-deep .van-field__control{
  color: #ccc;
}
.bc-body {
  padding: 1rem;
  border: 3px solid #ac7254;
  border-radius: 2rem;
}
.van-cell {
  font-size: 32px;
  line-height: 80px;
  background: none;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.bankbox {
  padding: 15px;
  color: #000;
  background-color: #fff;
}
.bankbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}
.main-box {
  // background: #fff;
}
.main-box .label {
  padding: 20px;
  font-size: 35px;
  color: #797878;
}
::v-deep .van-picker__toolbar {
  height: 50px;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  padding: 0 20px;
  font-size: 40px !important;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.bank-warning {
  margin: 0 30px;
  padding: 0 0.25rem;
  color: #ee0a24;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1.45;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #EEC094, #F3C7A2);
}
</style>
